import React from "react";
import { makeStyles } from 'tss-react/mui';
import useSettings from '../../hooks/useSettings';
import TicketsKanban from "../../components/TicketsKanban";
import Page from '../../components/Page';
import { i18n } from "../../translate/i18n";
import { Container, Grid } from '@mui/material';

const useStyles = makeStyles()((theme) => {
  return {
    kanbanWrapper: {
      display: "flex",
      height: "100%",
      flexDirection: "column",
      overflowY: "hidden",
    },
    ticketsKanban: {},
  }
});

const Kanban = () => {
  const { classes } = useStyles();
  const { themeStretch } = useSettings();

  return (
    <div style={{ marginTop: '10px' }}>
      <Page title={i18n.t("mainDrawer.listItems.kanban")}>
        <Container spacing={3} maxWidth={false} className={classes.mobileLayout}>
          <Grid container>
            <Grid
              item
              xs={12}
              className={classes.kanbanWrapper}
            >
              <TicketsKanban />
            </Grid>
          </Grid>
        </Container>
      </Page>
    </div>
  );
};

export default Kanban;
